import useSWR from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { SubscriptionStateInterface } from '../types/subscription-state-intarfece'

export function useDisplayUnsubscribeFromCampaign(messageId: string) {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    SubscriptionStateInterface
  >({ method: RequestMethodsEnum.get })
  return useSWR<SubscriptionStateInterface>(() => {
    return `/api/mailing/subscription-state/${messageId}`
  }, fetcher)
}
